module.exports = __webpack_public_path__ + "static/media/logo.d9d886fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 565
// module chunks = 0